import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import PrivacyContent from "./components/PrivacyContent";
import FloatingButton from "./components/FloatingButton";

export default function PolitiqueConfidentialite() {
  useSEO(seoData.politiqueConfidentialite);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <PrivacyContent />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}